import {Button as StyledButton} from './styles';
import {ButtonProps} from './types';

const Button: React.FC<ButtonProps> = (props) => <StyledButton {...props} />;

export default Button;
